<template>
  <div v-if="src">
    <top-bar/>
    <web-frame :src="src"/>
  </div>
</template>

<script>
  import WebFrame from "@/views/gestor/WebFrame";
  import TopBar from "@/components/commons/TopBar";

  export default {
    name: 'Documentacao',
    components: {TopBar, WebFrame},

    data() {
      return {
        src: null
      }
    },

    mounted() {
      this.src = 'https://lecard.tawk.help/';
    }
  }
</script>

<style scoped>
</style>
